<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="!persons.length && errors" @tryAgain="getPersons" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <div class="flex flex-col md:flex-row justify-between items-center md:items-center mb-6 lg:mb-8">
                <h3 class="flex items-center md:text-26 text-2xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('Persons') }}
                </h3>
                <div class="flex mt-6 md:mt-0 flex-col lg:flex-row w-full md:w-auto justify-end">
                    <div class="flex mt-4 lg:mt-0 justify-end">
                        <input
                            class="input w-full h-10 xl:pl-36 placeholder-gray-320 md:w-64 xl:w-80 ml-2 bg-gray-350 bg-opacity-10 rounded-lg  transition duration-200 text-sm text-gray-350 px-3 font-medium dark:!bg-base-300 dark:!text-white  focus:bg-blue-700 focus:bg-opacity-10 border border-blue-700  focus:border-opacity-100"
                            type="text" :placeholder="__('Search...')" v-model="searchValue">
                        <button @click="search"
                            class=" bg-blue-600 disabled:opacity-70 disabled:!bg-blue-600 flex items-center h-10 md:px-5 px-3 rounded-md text-white font-semibold text-sm transition duration-200 hover:bg-blue-800 ">
                            {{ __('Search') }}
                        </button>
                    </div>
                    <div class="flex order-first justify-between lg:order-last">
                        <Dropdown customClass="inline-block z-1"
                            :labelClass="['mr-2 px-2', { 'btn-outline': !hasFilter }]">
                            <template #label>
                                <FunnelIcon class="w-5 h-5" />
                            </template>
                            <div class="mt-3 card card-compact dropdown-content w-72 bg-base-100 shadow">
                                <div class="card-body">
                                    <div class="flex flex-col">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                            {{ __('Source') }}
                                        </label>
                                        <select class="select w-full max-w-xs" v-model="filters.source">
                                            <option value="">{{ __('Select...') }}</option>
                                            <option v-for="item in meta.sources" :value="item.id">
                                                {{ item.title }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="flex flex-col">
                                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                            {{ __('Birthday') }}
                                        </label>
                                        <select class="select w-full max-w-xs" v-model="filters.birthday">
                                            <option value="">{{ __('Select...') }}</option>
                                            <option v-for="item in birthdays" :value="item">
                                                {{ __(item.capitalize()) }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="card-actions">
                                        <button class="btn btn-primary btn-block" @click="setFilter">
                                            {{ __('Apply Filter') }}</button>
                                    </div>
                                </div>
                            </div>
                        </Dropdown>
                        <div class="flex justify-start order-first lg:order-last lg:mr-2 flex-1" v-if="can('person.create')">
                            <router-link :to="{ name: 'user.person.create' }" class="btn btn-outline btn-info btn-base">
                                <span class="mt-0.5">{{ __('Create person') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rounded-2xl dark:bg-base-300 bg-white">
                <TablePerson :persons="persons" @setItem="setItem" />
            </div>
            <Pagination :meta="meta" @setPage="setPage" class="!mt-6" />
        </div>
    </div>

    <ModalDelete @remove="removePerson" id="person-delete-modal" :title='__("Delete person")'
        :content='__("Are you sure to delete this person?")' />
</template>
<script setup>
import { ref, onMounted, computed, onUpdated } from 'vue';
import { FunnelIcon } from '@heroicons/vue/24/outline';
const { getPersons, loading, errors, meta, router, remove, route, persons, removePerson } = useDashboard();
const searchValue = ref(route.query.search || '');
const birthdays = ['yesterday','today', 'tomarrow'];
const { source, birthday } = route.query;
const filters = reactive({ source: source || '', birthday: birthday || ''});
const hasFiltered = () => Object.values(filters).filter(value => value).length;
const hasFilter = ref(hasFiltered());
const setFilter = () => {
    hasFilter.value = hasFiltered();
    getPersons(window.setQueries(router, { ...filters }));
}
const setQuery = (key, value) => {
    getPersons(window.setQuery(router, route, key, value));
}
const setPage = (p) => {
    setQuery('page', p.toString());
};
const setItem = (item) => Object.assign(remove, item);
const search = () => {
    setQuery('search', searchValue.value)
}
onMounted(() => {
    getPersons(route.query);
});
</script>